// @ts-ignore
import * as pdfMake from 'pdfmake/build/pdfmake'
// @ts-ignore
import * as pdfFonts from 'pdfmake/build/vfs_fonts'

export default defineNuxtPlugin(() => {
  pdfMake.vfs = pdfFonts.vfs

  return {
    provide: {
      pdfMake
    }
  }
})
